/* eslint-disable no-undef */

const DEVICE_INFO_UNKNOWN_PLACEHOLDER = "unknown";

export const DeviceSdk = {
  async uid() {
    try {
      const userGuid = await onesdk.getUserGuid();
      return userGuid + "|Home";
    } catch (error) {
      console.error("Failed to fetch onesdk.getUserGuid using OneSdk", error);
      throw new Error("Lightning SDK failure: cannot determine device id");
    }
  },
  async operator() {
    return "liberty";
  },
  async countryCode() {
    return "nl";
  },
  async platform() {
    return "eos";
  },
  async locale() {
    return navigator.language;
  },
  async householdId() {
    try {
      const userGuid = await onesdk.getUserGuid();
      return userGuid;
    } catch (error) {
      console.error("Failed to fetch onesdk.getUserGuid using OneSdk", error);
      return DEVICE_INFO_UNKNOWN_PLACEHOLDER;
    }
  },
  async city() {
    return DEVICE_INFO_UNKNOWN_PLACEHOLDER;
  },
  async ip() {
    return DEVICE_INFO_UNKNOWN_PLACEHOLDER;
  },
  async type() {
    try {
      return onesdk.getDeviceModel();
    } catch (error) {
      console.error("Failed to fetch onesdk.getDeviceModel using OneSdk", error);
      return DEVICE_INFO_UNKNOWN_PLACEHOLDER;
    }
  },
  async model() {
    return getModelFromUserAgent();
  },
  async mac() {
    return DEVICE_INFO_UNKNOWN_PLACEHOLDER;
  },
  generateDeviceId(options) {
    let deviceId = "";
    if (
      options.householdId &&
      options.householdId !== DEVICE_INFO_UNKNOWN_PLACEHOLDER &&
      options.uid &&
      options.uid !== DEVICE_INFO_UNKNOWN_PLACEHOLDER
    ) {
      deviceId = `${options.householdId}/${options.uid}`;
    } else {
      deviceId = options.uid;
    }
    return deviceId;
  },
  async initSdk() {
    const hasOneSdk = typeof onesdk !== "undefined";
    if (hasOneSdk) {
      try {
        await onesdk.init();
      } catch (error) {
        console.error("Failed to initialize One SDK", error);
        throw new Error("One SDK initialization failed");
      }
    }
  },
  async resumeChannel() {
    try {
      await onesdk.resumeBroadcast();
    } catch (error) {
      console.error("Failed to resume channel using OneSdk", error);
    }
  },
  async suspendChannel() {
    try {
      await onesdk.suspendBroadcast();
    } catch (error) {
      console.error("Failed to suspend channel using OneSdk", error);
    }
  },
  async getCurrentChannel() {
    try {
      const channelId = await onesdk.getCurrentChannelId();
      return onesdk.getChannelById(channelId);
    } catch (error) {
      console.error("Failed to fetch current channel using OneSdk", error);
    }
  },
  getOneSdkEventTypes() {
    return onesdk.EVENT_TYPES;
  },
  async tuneToChannelByNumber(channelNumber) {
    try {
      await onesdk.tuneToChannelByNumber(channelNumber);
    } catch (error) {
      console.error("Failed to tune to channel by number using OneSdk", error);
    }
  },
  async getChannelById(channelId) {
    try {
      return await onesdk.getChannelById(channelId);
    } catch (error) {
      console.error("Failed to fetch channel by ID using OneSdk", error);
      return null;
    }
  },
};

const getModelFromUserAgent = () => {
  /**
   * Try to extract device model from the user agent string
   * According to Ziggo, the user agent string is in the format "<browser> HZN/<version> (MN=<Model Name>;PC=<Product Class>;FV=<Firmware Version>;)"
   * We are interested in the Model Name, which is after MN= with a semicolon as a delimiter.
   */
  const match = navigator.userAgent.match(/MN=([^;]+)/);
  return match && match.length ? match[1] : DEVICE_INFO_UNKNOWN_PLACEHOLDER;
};

export default DeviceSdk;
